import {z} from 'zod';

/**
 * Ports define how data flows into and out of nodes.
 */
export const portDataTypeSchema = z.enum([
  'any',
  'string',
  'number',
  'boolean',
  'object',
  'array',
]);

export type PortDataType = z.infer<typeof portDataTypeSchema>;

export const portSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  type: portDataTypeSchema.default('any'),
  required: z.boolean().default(false),
  multiple: z.boolean().default(false),
  description: z.string().optional(),
});

export type Port = z.infer<typeof portSchema>;

export const createDefaultOutputPort = (): Port => ({
  id: 'output_main',
  name: 'main',
  type: 'any',
  required: false,
  multiple: false,
});

export const createDefaultInputPort = (): Port => ({
  id: 'input_main',
  name: 'main',
  type: 'any',
  required: true,
  multiple: false,
});
